const $ = require('jquery');

// need to move the breadcrumb block output to be a part of the page
// titles overlaid on top of the blue wave background
$('#block-altos-child-breadcrumbs').prependTo('#altos-page-title-content');
